var exports = {
  "Kk": "InviteEmbed.module__icon___NHNuQ1",
  "EU": "InviteEmbed.module__iconFallback___NHNuQ1",
  "C1": "InviteEmbed.module__titleRowWithIcon___NHNuQ1",
  "gn": "InviteEmbed.module__titleContainer___NHNuQ1",
  "Qw": "InviteEmbed.module__titleText___NHNuQ1",
  "fH": "InviteEmbed.module__headerInvite___NHNuQ1",
  "dT": "InviteEmbed.module__inviteWrapper___NHNuQ1",
  "M1": "InviteEmbed.module__stats___NHNuQ1",
  "dJ": "InviteEmbed.module__stat___NHNuQ1",
  "gW": "InviteEmbed.module__statDot___NHNuQ1",
  "rR": "InviteEmbed.module__statDotOnline___NHNuQ1",
  "rb": "InviteEmbed.module__statDotMembers___NHNuQ1",
  "KA": "InviteEmbed.module__statText___NHNuQ1",
};

module.exports = exports;
